/**
 * @desc OMS创建售后退货单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanOmsCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/createSaleIn`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
